import Blog, { AnalyticsEvent, AnalyticsStream, ServiceType } from 'react-markdown-blog';
import { useAnalytics } from './hooks/useAnalytics';

export const BlogWrapper: React.FC<{ config: any }> = ({ config }) => {
  const { trackEvent } = useAnalytics();

  const analyticsStream = new AnalyticsStream();
  analyticsStream.subscribe((event: AnalyticsEvent) => {
    trackEvent(event.type, event.data);
  });

  return (
    <Blog
      serviceType={{
        source: 'cdn',
        url: new URL('blog', config.api.cdnUrl).toString()
      } as ServiceType}
      footerName="Kamil Tałanda"
      analyticsStream={analyticsStream}
    />
  );
};